import {useSelector} from 'react-redux';

import {getDomainIncidentExpireFormat, getDomainMonitorDateFormat} from 'features/domain/lib/domainMonitorView';
import {userSelector} from 'entities/user';
import {isTranslate} from 'shared/lib/lang';

export interface IUseDomainMonitorChecksSummary {
    tzString: string | null | undefined,
    dateFormat: string,
    dateTimeFormat: string,
    isRknVisible: boolean,
}

export const useDomainMonitorChecksSummary = (): IUseDomainMonitorChecksSummary => {
    const user = useSelector(userSelector);
    const isEnglish = isTranslate();

    return {
        tzString: user?.timezone,
        dateFormat: getDomainMonitorDateFormat(isEnglish),
        dateTimeFormat: getDomainIncidentExpireFormat(isEnglish),
        isRknVisible: !isEnglish,
    };
};

export default useDomainMonitorChecksSummary;
